/**
 * WalletConnect / Reown Verify matches metadata.url to the page origin.
 * In an iframe the app runs on the iframe origin, not rocketfuel.inc.
 */
export function resolveAppKitMetadata() {
  let url = "https://rocketfuel.inc";
  if (typeof window !== "undefined" && window.location?.origin) {
    url = window.location.origin;
  }

  return {
    name: "Rocketfuel Inc",
    description: "Pay with RocketFuel",
    url,
    icons: [
      "https://ik.imagekit.io/rocketfuel/icons/rocketfuel-circular.svg?updatedAt=1726663710853",
    ],
  };
}
